import React from 'react';

const Title = ({ title }) => {
    return <div className="font-extrabold text-2xl pb-4 pt-7">{title}</div>;
};

export default Title;
